
	// import {
	// 	cloneDeep
	// } from 'lodash-es';
	import {
		FormOutlined,
		DeleteOutlined,
		PlusOutlined,
		MinusCircleOutlined
	} from '@ant-design/icons-vue';
	import {
		defineComponent,
		ref,
		reactive,
		createVNode
	} from 'vue';
	import infomechanism from '@/service/infomechanism'
	import mechanismindex from '@/service/mechanismindex'
	import {
		message,
		Modal
	} from 'ant-design-vue';

	export default defineComponent({
		components: {
			FormOutlined,
			DeleteOutlined,
			PlusOutlined,
			MinusCircleOutlined
		},
		setup() {
			// 声明
			let visible = ref(false);
			let addVisible = ref(false);
			let targetVisible = ref(false);
			const expandedKeys = ref([]);
			const addFormState = reactive({
				level: '1',
				levelName: '',
				id: '',
				tvParentid: '',
				tvParentidId: '',
				menuKey: ''
			});
			let targetFormState = reactive({
				schoolCode: "",
				taskId: "",
				id: "", //末级评审维度
				mechanismScore: "", //得分
				mechanismIndexList: [{
					indexName: "指标名称"
				}],

			});
			// 声明需用的全局参数
			const state = reactive({
				current: 1,
				total: 0,
				pageSize: 10,
				taskId: '',
				taskName: '',
				reviewLevel: '2',
				itemLevel: '',
				sameLevel: false,
				subordinateLevel: false,
				treeData: [],
				indicatorData: [],
				mechanismId: '',
				mechanismName: ''
			})
			const uploadForm = reactive({
				dataList: [],
			});
			// 打开页面
			const open = (e) => {
				state.taskName = e.taskName;
				state.taskId = e.id;
				state.reviewLevel = e.reviewLevel;
				visible.value = true;
				state.treeData = [];
				queryTree();
			}
			// 评审机制左侧树展示
			const queryTree = () => {
				state.treeData = [];
				infomechanism.queryMechanism(sessionStorage.getItem('schoolCode'), state.taskId).then(({
					data
				}) => {
					if (data.code !== 0) return;
					if (data.data) {
						if (data.data.infoMechanismList.length != 0) {
							data.data.infoMechanismList.map(item => {
								if (item.infoMechanismList.length != 0) {
									item.infoMechanismList.map(item1 => {
										if (item1.infoMechanismList.length != 0) {
											item1.infoMechanismList.map(item2 => {
												if (item2.infoMechanismList
													.length != 0) {
													item2.infoMechanismList
														.map(item3 => {
															if (item3
																.infoMechanismList
																.length !=
																0) {
																item3
																	.infoMechanismList
																	.map(
																		item4 => {
																			delete item4
																				.infoMechanismList;
																		})
															} else {
																delete item3
																	.infoMechanismList;
															}
														})
												} else {
													delete item2
														.infoMechanismList;
												}
											})
										} else {
											delete item1.infoMechanismList;
										}
									})
								} else {
									delete item.infoMechanismList;
								}
								return item;
							})
						} else {
							delete data.data.infoMechanismList;
						}
						let departTree = JSON.stringify(data.data);
						let dataList = JSON.parse(departTree.replace(/"itemName":/g, "\"title\":")
							.replace(/"id":/g, "\"key\":").replace(/"infoMechanismList":/g,
								"\"children\":"));
						state.treeData.push(dataList);
					}
				})
			}
			// 右键点击 新增|编辑|删除
			const onContextMenuClick = (treeKey, itemName, itemLevel, tvParentid, menuKey) => {
				addFormState.tvParentid = tvParentid;
				addFormState.tvParentidId = treeKey;
				addFormState.menuKey = menuKey;
				state.mechanismId = treeKey;
				state.mechanismName = itemName;
				let level = '';
				if (itemLevel.length == 4) {
					level = '0';
				} else if (itemLevel.length == 8) {
					level = '1';
				} else if (itemLevel.length == 12) {
					level = '2';
				} else if (itemLevel.length == 16) {
					level = '3';
				}
				state.itemLevel = level;
				if (menuKey == 'add') {
					addVisible.value = true;
					addFormState.levelName = '';
					addFormState.id = '';
					if (level == state.reviewLevel) {
						state.sameLevel = false;
						state.subordinateLevel = true;
						addFormState.level = '1';
					} else if (level == '0') {
						state.sameLevel = true;
						state.subordinateLevel = false;
						addFormState.level = '2';
					} else {
						state.sameLevel = false;
						state.subordinateLevel = false;
						addFormState.level = '1';
					}
				} else if (menuKey == 'edit') {
					addVisible.value = true;
					addFormState.levelName = itemName;
					addFormState.id = treeKey;
				} else if (menuKey == 'del') {
					Modal.confirm({
						title: '确认要删除么?',
						content: createVNode('div', {
							style: 'color:red;',
						}, ''),
						cancelText: '取消',
						okText: '确认',
						onOk() {
							infomechanism.delMechanism(treeKey).then(({
								data
							}) => {
								if (data.code == '0') {
									queryTree();
									message.success('删除成功');
								} else {
									message.error(data.msg);
								}
							})
						},
						onCancel() {
							console.log('Cancel');
						},
						class: 'test',
					});
				}
				if (level == state.reviewLevel) {
					queryMechanismindex(treeKey);
				}
			};
			// 选择树节点
			const onSelect = (selectedKeys, info) => {
				console.log('selectedKeys', selectedKeys);
				let dataRef = info.node.dataRef;
				state.mechanismId = dataRef.key;
				state.mechanismName = dataRef.title;
				let level = '';
				if (dataRef.itemLevel.length == 4) {
					level = '0';
				} else if (dataRef.itemLevel.length == 8) {
					level = '1';
				} else if (dataRef.itemLevel.length == 12) {
					level = '2';
				} else if (dataRef.itemLevel.length == 16) {
					level = '3';
				}
				state.itemLevel = level;
				if (level == state.reviewLevel) {
					queryMechanismindex(dataRef.key);
				} else {
					state.indicatorData = [];
					state.total = 0;
					state.current = 1;
					message.error('请选择最末级节点');
					return;
				}
			}
			// 指标列表
			const queryMechanismindex = (mechanismId) => {
				let dataJSON ={
					schoolCode:sessionStorage.getItem('schoolCode'),
					mechanismId:mechanismId,
				}
				mechanismindex.queryGetIndex(dataJSON).then(({
					data
				}) => {
					if (data.code !== 0) return;
					state.indicatorData = data.data;
					state.total = data.total;
					
				})
			}

			// 确认添加
			const addOk = () => {
				if (addFormState.levelName == '') {
					message.error('请填写评审维度名称');
					return;
				}
				let dataJson = {
					schoolCode: sessionStorage.getItem('schoolCode'),
					taskId: state.taskId,
					taskName: state.taskName
				}
				if (addFormState.id == '') {
					dataJson['itemName'] = addFormState.levelName;
					if (addFormState.level == '1') {
						dataJson['tvParentid'] = addFormState.tvParentid;
					} else {
						dataJson['tvParentid'] = addFormState.tvParentidId;
					}
					dataJson['itemName'] = addFormState.levelName;
					infomechanism.saveMechanism(dataJson).then(({
						data
					}) => {
						if (data.code == '0') {
							message.success(data.msg);
							addVisible.value = false;
							addFormState.levelName = '';
							addFormState.tvParentid = '';
							addFormState.tvParentidId = '';
							addFormState.id = '';
							addFormState.level = '1';
							queryTree();
						} else {
							message.error(data.msg);
						}
					})
				} else {
					dataJson['itemName'] = addFormState.levelName;
					dataJson['id'] = addFormState.id;
					dataJson['tvParentid'] = addFormState.tvParentid;
					dataJson['itemName'] = addFormState.levelName;
					infomechanism.updateMechanism(dataJson).then(({
						data
					}) => {
						if (data.code == '0') {
							message.success(data.msg);
							addVisible.value = false;
							addFormState.levelName = '';
							addFormState.tvParentid = '';
							addFormState.tvParentidId = '';
							addFormState.id = '';
							addFormState.level = '1';
							queryTree();
						} else {
							message.error(data.msg);
						}
					})
				}

			}
			// 修改指标内容
			const editIndicator = e => {
				targetFormState.mechanismScore = e.mechanismScore
				targetFormState.mechanismIndexList = ""
				uploadForm.dataList =e.mechanismIndexList
				targetPop(1)
			}
			// 添加 指标
			const addUser = () => {
				uploadForm.dataList.push({
					indexName: "",
				});
			};
			// 移除添加的 指标
			const removeUser = item => {
				let index = uploadForm.dataList.indexOf(item);
				if (index !== -1) {
					uploadForm.dataList.splice(index, 1);
				}
			};
			// 删除指标内容
			const delIndicator = (e) => {
				console.log(e)
				Modal.confirm({
					title: '确认要删除么?',
					content: createVNode('div', {
						style: 'color:red;',
					}, ''),
					cancelText: '取消',
					okText: '确认',
					onOk() {
						mechanismindex.delMechanismIndexTwo(e.id).then(({
							data
						}) => {
							if (data.code == '0') {
								queryMechanismindex(state.mechanismId);
								message.success('删除成功');
							} else {
								message.error(data.msg);
							}
						})
					},
					onCancel() {
						console.log('Cancel');
					},
					class: 'test',
				});


			}
			// 打开-添加指标内容-弹窗
			const targetPop = (e) => {
				if (state.itemLevel == state.reviewLevel) {
					if(e==0){ // 0新增 1修改
						targetFormState.mechanismScore = ""
						targetFormState.mechanismIndexList =[{indexName: ""}]
						uploadForm.dataList=[]
					}
					targetVisible.value = true;
				} else {
					message.error('当前节点不可添加指标, 请选择末级节点');
					return;
				}
			}
			//确认-添加指标内容
			const targetOk = () => {
				targetFormState.schoolCode = sessionStorage.getItem('schoolCode')
				targetFormState.taskId = state.taskId
				targetFormState.id = state.mechanismId
				targetFormState.mechanismIndexList = uploadForm.dataList
				if (targetFormState.mechanismIndexList.length < 1 || targetFormState.mechanismIndexList ==
					null || targetFormState.mechanismIndexList == []) {
					message.error('请填写评审内容');
					return;
				}
				if (targetFormState.mechanismScore == '') {
					message.error('请填写评审指标分数');
					return;
				}
				mechanismindex.saveMechanismIndexTwo(targetFormState).then(({
					data
				}) => {
					if (data.code == '0') {
						targetVisible.value = false;
						message.success(data.msg);
						queryMechanismindex(state.mechanismId);
					} else {
						message.error(data.msg);
					}
				})
			}

			return {
				addVisible,
				targetVisible,
				visible,
				open,
				expandedKeys,
				onContextMenuClick,
				addOk,
				addFormState,
				targetFormState,
				labelCol: {
					span: 5
				},
				wrapperCol: {
					span: 19,
				},
				labelCol2: {
					span:4
				},
				wrapperCol2: {
					span: 20,
				},

				editIndicator,
				delIndicator,
				state,
				targetOk,
				targetPop,
				queryTree,
				onSelect,
				queryMechanismindex,
				uploadForm,
				addUser,
				removeUser
			};
		},

	});
